import { Modal, ModalWithTransition } from '@studiometa/ui';

/**
 * Facets component
 */
export default class Search extends ModalWithTransition {
  timeout = null;

  /**
   * Component Configuration
   */
  static config = {
    name: 'Search',
    refs: [...Modal.config.refs, 'input', 'close', 'results', 'loader'],
    options: {
      styles: {
        type: Object,
        /**
         * @returns {ModalStylesOption}
         */
        default: () => ({
          modal: {
            closed: {
              pointerEvents: 'none',
              opacity: '0',
            },
            active: 'transition duration-300 ease-out-quad',
            open: {
              opacity: '1',
            },
          },
          overlay: {
            closed: 'opacity-0 pointer-events-none',
            open: 'opacity-100 pointer-events-auto',
            active: 'transition duration-300 ease-out-quad',
          },
          container: {
            closed: 'transform opacity-0',
            open: '',
            active: 'transition duration-300 ease-out-quad',
          },
          input: {
            closed: 'opacity-0 max-m:pointer-events-none',
            open: 'opacity-100 max-m:pointer-events-auto',
            active: 'transition duration-300 ease-out-quad',
          },
        }),
      },
    },
  };

  /**
   * Get input value
   * @returns {string} current value.
   */
  get searchTerm() {
    return this.$refs.input.value;
  }

  /**
   * Perform search when typing something in input
   * @returns {void}
   */
  onInputInput() {
    this.open();
    this.$refs.loader.style.display = 'block';

    clearTimeout(this.timeout);

    if (!this.searchTerm) {
      this.$refs.loader.style.display = 'none';
      return;
    }

    this.timeout = setTimeout(() => {
      fetch(
        `${window.routes.predictive_search_url}?q=${encodeURIComponent(this.searchTerm)}&section_id=predictive-search`,
      )
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;

          this.renderResults(results);
        })
        .catch((error) => {
          if (error?.code === 20) {
            // Code 20 means the call was aborted
            return;
          }
          throw error;
        });
    }, 800);
  }

  /**
   * Set results to the page
   * @param  {HTML} results products results
   * @returns {void}
   */
  renderResults(results) {
    this.$refs.loader.style.display = 'none';
    this.$refs.results.innerHTML = results;
  }

  /**
   * Open the modal
   * @returns {void}
   */
  open() {
    super.open();
    const topHeader = document.querySelector('.shopify-section-group-preheader-group');
    let topHeaderHeight = 0;

    if (topHeader) {
      topHeaderHeight = topHeader.offsetHeight;
    }

    if (window.pageYOffset <= topHeaderHeight) {
      this.$refs.modal.style.top = `calc(var(--header-height) + ${topHeaderHeight}px)`;
      this.$refs.overlay.style.top = `calc(var(--header-height) + ${topHeaderHeight}px)`;
    } else {
      this.$refs.overlay.style.top = `var(--header-height)`;
      this.$refs.modal.style.top = `var(--header-height)`;
    }

    this.$refs.input.focus();
  }
}
